import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const BigModuleHead = ({ content }) => {
    return (
        <div className={styles.bigModuleHead}>
            <div className={styles.title}>{content.name}</div>
            {content.moreUrl && (
                <a href={content.moreUrl} className={styles.more} target="_blank">
                    更多
                </a>
            )}
            {content?.adPic && (
                <a href={content?.adUrl || ''} target="_blank">
                    <img className={styles.zggd} src={content?.adPic} />
                </a>
            )}
        </div>
    );
};

BigModuleHead.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(BigModuleHead);
